import { useEffect, useState } from "react"
import { AiOutlineLoading3Quarters } from "react-icons/ai"
import { CloseIcon } from "../Icons"
import {
  loadTemplatesData,
  addTemplateToDb
} from "../../utils/giftcardControllers"

const PhysicalTemplateModal = ({ setModel }) => {
  const [loading, setLoading] = useState(true)
  const [importLoading, setImportLoading] = useState(false)
  const [templates, setTemplates] = useState([])
  const [error, setError] = useState("")

  useEffect(() => {
    fetchPhysicalTemplates()
  }, [])

  const fetchPhysicalTemplates = async () => {
    setLoading(true)
    setError("")

    try {
      const res = await loadTemplatesData(true)

      if (res?.success && res?.data?.length > 0) {
        const physicalTemplates = res.data[0]?.physical_templates || []

        // Normalize API response
        const formattedTemplates = physicalTemplates.map((url) => ({
          image_url: url
        }))

        setTemplates(formattedTemplates)
      } else {
        setTemplates([])
        setError(res?.message || "No physical templates found")
      }
    } catch (err) {
      setError("Something went wrong while fetching templates")
    } finally {
      setLoading(false)
    }
  }

  const handleUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return

    const reader = new FileReader()

    reader.onloadend = async () => {
      try {
        setImportLoading(true)
        const base64 = reader.result.split(",")[1]
        const res = await addTemplateToDb(base64, "", true)

        if (res.success) {
          fetchPhysicalTemplates()
        } else {
          alert(res.message)
        }
      } catch (err) {
        alert(err.message)
      } finally {
        setImportLoading(false)
        e.target.value = ""
      }
    }

    reader.readAsDataURL(file)
  }

  return (
    <div className="physical-modal-opener">
      <div className="physical-modal-container physical-view-template">
        {/* Header */}
        <div className="physical-modal-header">
          <h3>Physical Template Images</h3>
          <button onClick={() => setModel(false)}>
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="physical-modal-body">
          {loading ? (
            <div className="physical-loading-container">
              <AiOutlineLoading3Quarters className="physical-spinner" />
            </div>
          ) : error ? (
            <p className="physical-error">{error}</p>
          ) : (
            <>
              {/* Templates Grid */}
              <div className="physical-template-category-images">
                {templates.length > 0 ? (
                  templates.map((item, index) => (
                    <div key={index} className="physical-image-checkbox-container">
                      <img src={item.image_url} alt="template" />
                    </div>
                  ))
                ) : (
                  <p>No physical templates found</p>
                )}
              </div>

              {/* Upload */}
              <div className="physical-add-image-container">
                <label htmlFor="physical-template-upload">
                  {importLoading ? "Uploading..." : "Upload Physical Template"}
                </label>
                <input
                  id="physical-template-upload"
                  type="file"
                  accept="image/*"
                  disabled={importLoading}
                  onChange={handleUpload}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default PhysicalTemplateModal

